import React from 'react';
import classnames from 'classnames';
import { Radio } from 'antd';
import { presetFilters, getFilterFromRules } from '@utils';
import { defaultProps } from './propTypes';
import styles from './index.less';

function DataSourceFilter(props) {
  const { presetFid } = props;
  const selectedValue = presetFid || 'all';

  // apply selected preset filter
  function applyPresetFilter(val) {
    const { applyFilter, resetDrillDown, pushDrilldownFilter } = props;

    // default
    let newFilter = { name: 'All Traffic', rule: [] };

    // generate filter
    if (val in presetFilters) {
      const filterRules = presetFilters[val];
      newFilter = getFilterFromRules(filterRules);
      newFilter.presetFid = val;
    }

    // apply and reset drill down
    applyFilter(newFilter);
    resetDrillDown();
    if (val !== 'all') {
      pushDrilldownFilter(newFilter.name, newFilter.rule, val);
    }
  }

  // handle value change
  function onChange(ev) {
    const { value } = ev.target;
    applyPresetFilter(value);
  }

  // render toggle
  return (
    <div className={classnames(styles.filterWrap)}>
      <Radio.Group
        onChange={onChange}
        value={selectedValue}
        style={{
          marginRight: '10px',
        }}
      >
        <Radio.Button className={styles.btn} value="client-side">
          Client Side
        </Radio.Button>
        <Radio.Button className={styles.btn} value="server-side">
          Server Side
        </Radio.Button>
        <Radio.Button className={styles.btn} value="vpaid">
          VPAID
        </Radio.Button>
        <Radio.Button className={styles.btn} value="all">
          All
        </Radio.Button>
      </Radio.Group>
    </div>
  );
}

export default DataSourceFilter;

DataSourceFilter.defaultProps = defaultProps;
